// extracted by mini-css-extract-plugin
export default {"page":"page__4f2a105a","body":"body__4f2a105a","product_cards_container":"product_cards_container__4f2a105a","pagination_container":"pagination_container__4f2a105a"};